import React from 'react';

import { Footer } from '@/components/layout/Footer';
import { Navbar } from '@/components/layout/Navbar';
import { SkipLink } from '@/components/layout/SkipLink';

interface PageLayoutProps {
  /** Extra menu path to highlight, e.g. the category page of the article being read. */
  activeNavPath?: string;
  children: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ activeNavPath, children }) => (
  <div className="min-h-screen bg-black text-white font-sans selection:bg-neon-red selection:text-white">
    <SkipLink />
    <Navbar activePath={activeNavPath} />

    <main id="main-content" className="relative">
      {children}
    </main>

    <Footer />
  </div>
);
